import Base from "pages/Home";
import "./styles/bootstrap.scss";
import Header from "components/header/Header";
import Footer from "components/footer/Footer";
import { Route, Routes, useLocation } from "react-router-dom";
import Watermark from "components/Watermark";

function App() {
  const location = useLocation();
  const hideHeaderFooter = location.pathname.includes("/tasks");

  return (
    <>
      <Watermark />
      {!hideHeaderFooter && <Header />}
      <Routes>
        <Route path="/*" element={<Base />} />
      </Routes>
      {!hideHeaderFooter && <Footer />}
    </>
  );
}

export default App;
